let service = function (
	$q, 
	$rootScope, 
	Session, 
	$state, 
	$stateParams, 
	$window, 
	Http
) {
	"ngInject";
	
	$rootScope.language = (Session.get('language') ? Session.get('language') : 'nl');	
	
	this.change = function(language) {
		Session.set('language', language);
		$rootScope.language = language;
	};
	
	this.translations = function() {

		var q = $q.defer();
		var translations = Session.get('translations');
		
		if (translations) {
			Http.get('/v1/translations').then(function(res) {
				Session.set('translations', res);
			});
			q.resolve(translations);
		} else {
			Http.get('/v1/translations').then(function(res) {
				Session.set('translations', res);
				q.resolve(res);
			});
		}

		return q.promise;

	};
	
	this.get = function() {
		return $rootScope.language;
	};

}

export default service;


// WEBPACK FOOTER //
// ./app/shared/services/language.service.js